function formatCurrency(value) {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`
  if (value >= 1000) return `$${Math.round(value / 1000)}K`
  return `$${value}`
}

const badgeStyles = {
  adequate: {
    bg: 'bg-green-100 dark:bg-green-900/30',
    text: 'text-green-700 dark:text-green-400',
    label: 'Adequate',
  },
  partial: {
    bg: 'bg-amber-100 dark:bg-amber-900/30',
    text: 'text-amber-700 dark:text-amber-400',
    label: 'Partial',
  },
  inadequate: {
    bg: 'bg-red-100 dark:bg-red-900/30',
    text: 'text-red-700 dark:text-red-400',
    label: 'Inadequate',
  },
  none: {
    bg: 'bg-gray-100 dark:bg-gray-700/30',
    text: 'text-gray-600 dark:text-gray-400',
    label: 'None',
  },
}

function InsuranceAdequacyCard({ adequacy }) {
  if (!adequacy) return null

  const rawStatus = adequacy.overallAdequacy || adequacy.status || 'None'
  const status = rawStatus.toLowerCase()
  const badge = badgeStyles[status] || badgeStyles.none

  if (status === 'none') {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400">
        No cyber insurance coverage in place
      </p>
    )
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${badge.bg} ${badge.text}`}>
          {badge.label}
        </span>
        {adequacy.coverageLimit != null && (
          <span className="text-sm text-gray-600 dark:text-gray-300">
            Coverage: {formatCurrency(adequacy.coverageLimit)}
          </span>
        )}
        {adequacy.coverageScore != null && (
          <span className="text-sm text-gray-500 dark:text-gray-400">
            Score: {Math.round(adequacy.coverageScore)}%
          </span>
        )}
      </div>

      {adequacy.gaps?.length > 0 && (
        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">
            Coverage Gaps
          </p>
          <ul className="space-y-1">
            {adequacy.gaps.slice(0, 3).map((gap, i) => (
              <li key={i} className="text-sm text-gray-600 dark:text-gray-300 flex items-start gap-1.5">
                <span className="text-red-400 mt-0.5">&#8226;</span>
                {gap}
              </li>
            ))}
          </ul>
        </div>
      )}

      {adequacy.recommendedCoverage != null && (
        <div className="border-t border-gray-100 dark:border-gray-700/30 pt-3">
          <div className="flex items-baseline gap-3 flex-wrap">
            <span className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Recommended Coverage
            </span>
            <span className="text-lg font-semibold text-gray-900 dark:text-white">
              {formatCurrency(adequacy.recommendedCoverage)}
            </span>
            {adequacy.recommendedCoverageBindingAnchor === 'scenario' && (
              <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400">
                Floor: worst single event
              </span>
            )}
          </div>
          {adequacy.recommendedCoverageRationale && (
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1.5 leading-relaxed">
              {adequacy.recommendedCoverageRationale}
            </p>
          )}
        </div>
      )}

      {adequacy.reserveRecommendation && (
        <div className="text-sm">
          <p className="text-gray-600 dark:text-gray-300">
            <span className="text-gray-500 dark:text-gray-400">Recommended reserve:</span>{' '}
            <span className="font-semibold text-gray-900 dark:text-white">
              {formatCurrency(typeof adequacy.reserveRecommendation === 'object' ? adequacy.reserveRecommendation.recommendedReserve : adequacy.reserveRecommendation)}
            </span>
          </p>
          {typeof adequacy.reserveRecommendation === 'object' && adequacy.reserveRecommendation.reason && (
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{adequacy.reserveRecommendation.reason}</p>
          )}
        </div>
      )}
    </div>
  )
}

export default InsuranceAdequacyCard
